import "./FormItemSwitch.scss";
import { Form, Switch } from "antd";
import React from "react";

interface FormItemSwitchProps {
  name: string;
  label: string;
  rules: { required: boolean; message?: string };
  defaultValue?: boolean;
  disabled?: boolean;
}

const FormItemSwitch: React.FC<FormItemSwitchProps> = ({
  name,
  rules,
  label,
  defaultValue,
  disabled,
}) => {
  return (
    <Form.Item
      className={`form-item__switch`}
      name={name}
      label={label}
      rules={[{ required: rules.required, message: rules.message }]}
      layout={"horizontal"}
    >
      <Switch className={"switch"} defaultValue={defaultValue} disabled={disabled} />
    </Form.Item>
  );
};

export default FormItemSwitch;
